import React, { FC, useEffect } from 'react';
import { AuthTemplate } from '@components/4-templates';
import { withForwardedNavigationParams } from 'react-navigation-props-mapper';

import Success from '@assets/success'
import { ForwardedPageProps } from '@lib/constants';
import { Spacer, Text } from '@components/1-atoms';
import { useBusiness } from '@lib/hooks/useBusiness';
import { Button } from '@components/2-molecules';

const Check: FC<ForwardedPageProps> = ({ navigation }) => {

    const [business] = useBusiness();

    const checkAndGoToDashboard = () => navigation.navigate("Dashboard", {});

    return (
        <AuthTemplate noPadding={true} hooks={[business]}>

            <Spacer h={6} />
            <Success />
            <Spacer h={3} />

            <Text bold color='#FFF'>{business?.data?.name}</Text>
            <Spacer h={1} />
            <Text bold large color='#FFF'>You are all set!</Text>
            <Spacer h={6} />

            <Button onPress={checkAndGoToDashboard}>GO TO DASHBOARD</Button><Spacer h={1} />
        </AuthTemplate>
    );
};

export default withForwardedNavigationParams<ForwardedPageProps>()(Check);
